<template>
  <div class="tal pginner pcinner">
    <div class="entry-header">
      <div class="erntrybox">
        <div class="slttl">
          <h1 itemprop="name" class="entry-title topbox tac">プライバシーポリシー</h1>
        </div>
      </div>
    </div>
    <div class="entry-content pdhboxM">
      <section class="outbok pdvboxS">
        <h1 class="httl2 mh fcgr">個人情報の収集および利用について</h1>
        <p>
          個人情報とは、特定の個人を特定する、または特定の個人に連絡するために利用できるデータのことを指します。当サイトでは、個人情報の収集および利用することはございませんのでご安心ください。
        </p>
      </section>
      <section class="outbok pdvboxS">
        <h1 class="httl2 mh fcgr">非個人情報の収集および利用について</h1>
        <p>
          当社が扱う情報には、そのままでは特定の個人と直接関連付けられることのない非個人情報があります。当社は、様々な目的で、非個人情報を収集、利用、移転および開示することがあります。以下は、当社が収集する非個人情報の種類およびその利用方法の例です。
        </p>
        <section class="pdboxS">
          <h2 class="httl3 mh fcgr">Cookie(クッキー)、その他の技術の利用について</h2>
          <p>
            当サイトでは、「Cookie」やその他の技術を利用し、ユーザーがサイトを利用する際の利便性の向上や、当社がユーザの行動をより良く理解するために非個人情報を利用しています。例えば、お気に入り情報や、広告などがそれにあたります。これらの情報で個人を特定することは出来ません。
          </p>
          <p>
            また、一部広告については、当該第三者が、当サイトを訪問したユーザーのCookie情報等を取得することがあります。ここで取得されたクッキー情報等は、当該第三者のプライバシーポリシーに従って取り扱われるため、弊社の管理管轄外になります。
          </p>
        </section>

      </section>
      <section class="outbok pdvboxS">
        <h1 class="httl2 mh fcgr">継続的改善について</h1>
        <p>
          当社は、当サイトを利用するユーザーの利便性や当社の運営状況を鑑みて、適宜個人情報の取扱いを見直し、継続的な改善に努めます。その上で、必要に応じて本プライバシーポリシーを変更することがあります。
        </p>
      </section>
      <p class="tal">
        以上
      </p>
      <p>
        <span class="published">2013年10月1日制定</span><br><span class="updated">2016年3月1日改訂</span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'about',
  components: {
    // HelloWorld
  },
  mounted: function(){
    let title = 'プライバシーポリシー'
    let description = 'sports styleのプライバシーポリシー。個人情報の収集および利用についての説明など。'
    this.setHeader(title, description, true)
    this.$store.commit('chageHeadTitle', title)
  }
}
</script>
